import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import store from './store';
import App from './pages/local-office-info.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

// init app
const el = document.querySelector('#local-office-info');
if (el) {
	new Vue({
		store,
		components: {
			app: App,
		},
	}).$mount('#local-office-info');
}
